import * as _ from 'lodash';

export class EventEmitter {
  listeners: any = {};
  onceListeners: any = {};

  constructor() {}

  on(event: string, fn?: Function, context?) {
    if (!fn) {
      console.warn('subscribe for %s has no fn', event);
      return () => {};
    }
    this.listeners[event] = this.listeners[event] || [];
    this.listeners[event].push({
      fn: fn,
      context: context,
    });

    // Return a function that, when called, will turn off the event
    return () => {
      this.off(event, fn);
    };
  }

  only(event: string, fn?: Function) {
    if (!fn) {
      console.warn('subscribe for %s has no fn', event);
      return () => {};
    }
    this.clearEvents(event);
    this.on(event, fn);
  }

  once(event: string, fn?: Function, context?) {
    if (!fn) {
      console.warn('subscribe for %s has no fn', event);
      return () => {};
    }
    this.onceListeners[event] = this.onceListeners[event] || [];
    this.onceListeners[event].push({
      fn: fn,
      context: context,
    });
  }

  off(event, fn?: Function) {
    this.listeners[event] = _.filter(this.listeners[event], d => {
      return d.fn !== fn;
    });

    this.onceListeners[event] = _.filter(this.listeners[event], d => {
      return d.fn !== fn;
    });
  }

  emit(event: string, ...args) {
    // timeout because we dont' want errors to affect things downstream
    setTimeout(() => {
      _.each(this.listeners[event], d => {
        d.fn.apply(d.context || this, args);
      });
      _.each(this.onceListeners[event], d => {
        d.fn.apply(d.context || this, args);
      });
      this.onceListeners[event] = [];
    });
  }

  clearEvents(event: string) {
    this.listeners[event] = [];
  }
}



// WEBPACK FOOTER //
// ./src/includes/eventEmitter.ts